import { render, staticRenderFns } from "./GenericCategoryItem.vue?vue&type=template&id=0a44b7ce&scoped=true&"
import script from "./GenericCategoryItem.vue?vue&type=script&lang=js&"
export * from "./GenericCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./GenericCategoryItem.vue?vue&type=style&index=0&id=0a44b7ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44b7ce",
  null
  
)

export default component.exports